import { useMemo } from 'react';

import { RoomType } from 'src/common/interfaces/room';

export const useAnswerMask = ({ roomType, answerPlaceholder }: { roomType?: RoomType; answerPlaceholder: string }) => {
  const isChallengeRoom = roomType === 'challenge';
  const maskPlaceholder = useMemo((): string | undefined => {
    if (isChallengeRoom) {
      return undefined;
    }

    return answerPlaceholder.match(/Answer format:\s(.+)$/)?.[1]?.replace(/\*/g, '_');
  }, [answerPlaceholder, isChallengeRoom]);

  const fixedCharIndexes = useMemo(
    () => [...answerPlaceholder.replace(/Answer format:\s/, '').matchAll(/_/g)].map((match) => match.index),
    [answerPlaceholder],
  ) as number[];

  return {
    maskPlaceholder,
    fixedCharIndexes,
  };
};
